import SVG from 'svg.js/dist/svg'

export default {
  install: Vue => {
    Vue.prototype.$svg = SVG
  }
}
